import React from 'react';
import styles from './styles.module.css';
import BannerCta from '@/components/general/BannerCta';
import MainIcons from '@/icons/main';
import { useLayoutContext } from '@/context/LayoutContext';
import PageCard from '@/components/general/PageCard';
import Guaranty from './Guaranty';

export default function SideBar() {
  const { guarantees } = useLayoutContext();
  const analysis = {
    title: 'تحلیل کارا',
    description:
      'قیمت این کالا ۱۵٪ پایین‌تر از میانگین ۳۰ روز اخیر است و بهترین زمان خرید محسوب می‌شود. سازگاری با خودروی فعال شما تأیید شد.',
  };
  return (
    <aside className={styles.wrapper}>
      <BannerCta>
        <div className={styles.analysisContent}>
          <div className={styles.analysisHeader}>
            <MainIcons.notifIcon fill="var(--accent)" />

            <span>{analysis.title}</span>
          </div>

          <p className={styles.analysisText}>{analysis.description}</p>
        </div>
      </BannerCta>
      <Guaranty />
    </aside>
  );
}
